import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose(pure);

const button = enhance(({ id, readOnly, onClickAction, className }) => {
  return (
    <Button
      className={className}
      color="secondary"
      onClick={() => {
        onClickAction(id, readOnly);
      }}
    >
      解除
    </Button>
  );
});

export default withStyles(styles)(button);
